@import '../../../../style/lib/scss';

.zds-backdrop {
	backdrop-filter: blur(var(--zds-backdrop-blur));
	background: var(--zds-backdrop-background);
	display: block;
	inset: 0;
	position: fixed;
	transition:
		visibility 0s,
		opacity var(--zds-transition-md);
	z-index: 1000;

	&--hide {
		opacity: 0;
		transition:
			visibility 0s 300ms,
			opacity var(--zds-transition-md);
		visibility: hidden;
	}

	&--close {
		cursor: pointer;
		position: absolute;
		right: 26px;
		top: 26px;

		@include zds-media-breakpoint-down('xs') {
			right: 6px;
			top: 12px;
		}
	}
}
